// Considered: EdgeCaseCalloutMolecule — rejected because it hardcodes marketplace.* i18n keys and a
// marketplace-scoped BEM root; this banner must be context-agnostic (message injected by the
// caller). Built on MessageAtom (full-width, severity-keyed, iconClass override) instead. See spec
// Reuse Audit.
//
// Informational, not a warning: a platform context is perfectly usable everywhere — only in-place
// editing is unavailable. Per the design this bar is a full-width, text-only notice; the
// "Save as copy to edit" action lives in the editor toolbar (the page's primary action slot), not
// inside the banner.
import React from 'react';
import MessageAtom from '../../atoms/Message/MessageAtom';
import './ContextProvenanceBannerMolecule.scss';

/** The `approach` variant is SOON — `Context` has no `source` field and no approach↔context link exists. */
export type ContextProvenanceSource = 'platform';

export interface ContextProvenanceBannerMoleculeProps {
  source: ContextProvenanceSource;
  /** Resolved (already-translated) banner copy. */
  message: string;
}

const ContextProvenanceBannerMolecule: React.FC<ContextProvenanceBannerMoleculeProps> = ({
  source,
  message,
}) => {
  return (
    <MessageAtom
      severity="info"
      iconClass="pi pi-info-circle"
      className={`context-provenance-banner-molecule context-provenance-banner-molecule--${source}`}
      data-testid="context-provenance-banner"
      text={<span className="context-provenance-banner-molecule__message">{message}</span>}
    />
  );
};

export default ContextProvenanceBannerMolecule;
